// ACCESS COLORS
export let getColor = (colorVar) => {
    let color = getComputedStyle(document.documentElement)
    .getPropertyValue(colorVar);
    return color;
}


